<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
        >
          新增
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.id === '' ? '新增' : '修改') + '企业账册信息'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="120px"
      >
        <el-form-item label="电商企业">
          <el-select
            filterable
            :disabled="formData.id !== ''"
            v-model="formData.enterpriseNid"
          >
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="口岸">
          <el-select filterable v-model="formData.portNid">
            <el-option
              v-for="item in portList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账册类型">
          <el-select v-model="formData.type">
            <el-option
              v-for="item in bookTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账册编码">
          <el-input v-model="formData.accountBookNo"></el-input>
        </el-form-item>
        <el-form-item label="担保企业">
          <el-select filterable v-model="formData.assureCode">
            <el-option
              v-for="item in getAssureECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      bookTypeList: [
        { value: "0", label: "海关账册" },
        { value: "1", label: "虚拟账册" }
      ],
      formData: {
        id: "",
        enterpriseNid: "",
        portNid: "",
        accountBookNo: "",
        type: "",
        assureCode: "",
        remark: "",
        creator: "",
        modifier: ""
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center"
        },
        {
          title: "企业",
          minWidth: 300,
          key: "enterpriseName",
          align: "center"
        },
        {
          title: "口岸",
          width: 90,
          key: "portName",
          align: "center"
        },
        {
          title: "账册编码",
          width: 120,
          key: "accountBookNo",
          align: "center"
        },
        {
          title: "担保企业",
          width: 300,
          key: "assureName",
          align: "center"
        },

        {
          title: "账册类型",
          minWidth: 90,
          key: "type",
          align: "center"
        },
        {
          title: "备注",
          minWidth: 300,
          key: "remark",
          align: "center"
        },
        {
          title: "创建人",
          width: 120,
          key: "creator",
          align: "center"
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center"
        },
        {
          title: "修改人",
          width: 160,
          key: "modifier",
          align: "center"
        },
        {
          title: "修改时间",
          width: 180,
          key: "gmtModified",
          align: "center"
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <a
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </a>
              );
            }
            return operation;
          }
        }
      ],
      filterObj: {},
      currentRow: [],
      sortObj: {}
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user",
      getPECommerce: "getPECommerce",
      getEECommerce: "getEECommerce",
      getAssureECommerce: "getAssureECommerce",
      portList: "portList"
    }),
    ...mapState("channelStore", {
      allChannelList: "allChannelList"
    })
  },
  methods: {
    ...mapActions("customsAccountBookStore", {
      list: "listAccountList",
      addOrModify: "bindOrUpdate",
      adjustStockPageQuery: "adjustStockPageQuery"
    }),
    fetch() {
      this.adjustStockPageQuery({
        request: {
          pageInfo: {
            currentPage: 1,
            pageSize: 10
          }
        }
      });
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        })
      };

      this.list(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(error => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData = { ...data };
        this.formData.type = data.type === "海关账册" ? "0" : "1";
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.formData.modifier = this.formData.creator = this.userInfo.nick;
      let param = { request: JSON.stringify({ data: this.formData }) };
      this.addOrModify(param)
        .then(res => {
          if (res.value) {
            this.showFormDialog = !this.showFormDialog;
            this.fetch();
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        })
        .catch(error => {
          this.$message.error("未知异常");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "电商企业",
              model: "enterpriseNid",
              type: type.SELECT,
              props: {
                data: this.getEECommerce
              }
            },
            {
              label: "口岸",
              model: "portNid",
              type: type.SELECT,
              props: {
                data: this.portList
              }
            },
            {
              label: "账册类型",
              model: "type",
              type: type.SELECT,
              props: {
                data: this.bookTypeList
              }
            }
          ]
        }
      ];
    }
  }
};
</script>
